import Vue from 'vue'
import env from './env'
import AgModal from '@/components/Modal'
import AgSelect from '@/components/Modal/Select'

const ModalClass = Vue.extend(AgModal)

function showModal (component, props, fullscreen, width, classes) {
  return new Promise(resolve => {
    let body = document.body
    let modal = new ModalClass({
      propsData: {
        fullscreen,
        width,
        classes
      }
    })
    let done = event => {
      body.removeChild(modal.$el)

      resolve(event)
    }

    if (typeof component === 'object') {
      modal.$slots.default = [
        modal.$createElement(component, {
          props,
          on: {done}
        })
      ]
    }

    modal.$on('done', done)
    modal.$mount()

    body.appendChild(modal.$el)
  })
}

function selectDialog (caption, options, cancelText) {
    return showModal(AgSelect, {caption, cancelText, options})
}

function alertDialog (options) {
  return new Promise(resolve => {
    alert(options.message || options)

    resolve()
  })
}

function confirmDialog (options) {
  return new Promise(resolve => {
    resolve(confirm(options.message || options))
  })
}

function promptDialog (options, defaultText) {
  return new Promise(resolve => {
    resolve(prompt(options.message || options, options.defaultText || defaultText))
  })
}

function componentDialog (component, props, fullscreen, width, classes) {
  let max = Math.round(env.width - 30)

  return showModal(component, props, fullscreen, width > max ? max : width, classes)
}

export default {
  select: selectDialog,
  alert: alertDialog,
  confirm: confirmDialog,
  prompt: promptDialog,
  component: componentDialog
}
